const FrontendLayout = ({ children }) => {
    return children;
};

export default FrontendLayout;
